import {Component} from '@angular/core';


@Component({
    selector: 'tfl-panel-details-column',
    template: `
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <ng-content></ng-content>
        </div>
    `
})
export class PanelDetailsColumnComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/panel-details/panel-details.column.component.ts